import { memo, type FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppAvatar } from "@/shared/Components";
import type { PersonInfo } from "./types";
import styles from "./styles.module.scss";

export const PersonRecord: FC<PersonInfo> = memo(
  ({ avatar, selected, group, name, title, avatarSize, disabled, textColor, onAvatarClick }) => {
    const { t } = useTranslation();

    return (
      <div className={classNames(styles.root, { [styles.disabled]: disabled })}>
        <div className={styles.avatar}>
          <AppAvatar
            onClick={onAvatarClick}
            selected={selected}
            name={name}
            image={avatar}
            avatarSize={avatarSize}
          />
        </div>
        <div>
          <div style={{ color: textColor }} className={styles.group} data-person="group">
            {group && t(`contactsPage.groups.${group.toLowerCase()}`)}
          </div>
          <div style={{ color: textColor }} className={styles.name} data-person="name">
            {name}
          </div>
          <div style={{ color: textColor }} className={styles.title} data-person="title">
            {title}
          </div>
        </div>
      </div>
    );
  },
);
